import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cigna-mfa-timeout-modal',
  templateUrl: './mfa-timeout-modal.component.html',
  styleUrls: ['./mfa-timeout-modal.component.scss'],
})
export class MfaTimeoutModalComponent implements OnInit {
  TIMEOUT = 'TIMEOUT';
  RESEND_EXCEED_LIMIT = 'RESEND_EXCEED_LIMIT';
  CODE_EXCEED_LIMIT = 'INCORRECT_CODE_EXCEED_LIMIT';

  constructor(
    private dialogRef: MatDialogRef<MfaTimeoutModalComponent>,
    @Inject(MAT_DIALOG_DATA) public reason: string,
  ) {}

  ngOnInit() {}
  continue() {
    this.dialogRef.close();
  }
}
